import { useId } from "react";
import { inventoryVisual } from "@/lib/inventoryVisuals";

export const InventoryIcon = ({ item, className = "h-4 w-4", testId }) => {
  const id = useId();
  const { icon: Icon, color, key, label } = inventoryVisual(item);
  return <Icon data-testid={testId || `inventory-icon-${id}`} data-inventory-icon={key} aria-label={label} role="img" className={`${className} shrink-0`} style={{ color }} />;
};

export const InventoryName = ({ item, className = "text-sm", testId, children }) => {
  const id = useId();
  return <span data-testid={testId || `inventory-name-${id}`} className={`inventory-name ${className}`} style={{ color: inventoryVisual(item).color }}>{children || item?.name || item?.label || "Item"}</span>;
};